export default "__VITE_ASSET__BOs6BgC8__"